import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          // here we will place our translations...
          description: {
            defaultHeader: "Stranger, wanna see you life in blocks?",
            loginHeader: ", this is all your ",
            loginHeaderYear: "year ",
            loginHeaderWeek: "week ",
            loginHeaderBlock: "blocks",
            language: "Which language do you prefer: ",
            formName: "Then, please spell your firstname: ",
            formNamePlaceholder: "Stranger",
            formBirth: "input your birthday: ",
            formAge: "and number of years you want to live: ",
            formSubmit: "DONE",
            footerReset: "RESET",
          },
        },
      },
      zh: {
        translation: {
          description: {
            defaultHeader: "陌生人，想看看你人生有多少可爱的小方块吗？",
            loginHeader: "，这是你所有的",
            loginHeaderYear: "年",
            loginHeaderWeek: "周",
            loginHeaderBlock: "块",
            language: "你习惯哪种语言：",
            formName: "那么，请先留下你的名字：",
            formNamePlaceholder: "陌生人",
            formBirth: "还有你的生日：",
            formAge: "最后是你想追踪多少年的人生：",
            formSubmit: "出 发",
            footerReset: "重 置",
          },
        },
      },
    },
  });

export default i18n;
